function initLinkCursor() {
    const cursor = document.getElementById('link-cursor');
    if (!cursor) {
        return;
    }

    const canHover = window.matchMedia?.('(hover: hover) and (pointer: fine)')?.matches;
    if (!canHover) {
        return;
    }

    document.body.classList.add('custom-cursor-enabled');

    let hasMoved = false;

    document.addEventListener('mousemove', (e) => {
        if (!hasMoved) {
            hasMoved = true;
            cursor.style.opacity = '1';
        }
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
    }, { passive: true });

    // Hide until the first move so it doesn't start at (0,0)
    cursor.style.opacity = '0';

    // Delegation so it works for all links (including dynamically added ones).
    document.addEventListener('pointerover', (e) => {
        const a = e.target?.closest?.('a[href]');
        if (!a) return;

        // Don't show for empty anchors
        const href = a.getAttribute('href') || '';
        if (!href || href === '#') return;

        cursor.classList.add('is-link');
    });

    document.addEventListener('pointerout', (e) => {
        const a = e.target?.closest?.('a[href]');
        if (!a) return;

        const related = e.relatedTarget;
        if (related && a.contains(related)) {
            return;
        }

        cursor.classList.remove('is-link');
    });

    window.addEventListener('pagehide', () => {
        cursor.style.opacity = '0';
        cursor.classList.remove('is-link');
        hasMoved = false;
    });
}

document.addEventListener('DOMContentLoaded', initLinkCursor);
